import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import pathname from '../../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import MainProjectInfo from '../../../widgets/projectBasedItemsWidget/MainProjectInfo'
import ProjectCoMakerWidget from '../../../widgets/projectProposal/projectCoMaker/PCoMakerWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID, TEMP_FORM_ID } from '../../../constants/constants'
import { getFormProjectCoMaker } from '../../../redux/actions/subProjectProposal'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import { getSettingFormProjectCoMakerPreView } from '../../../redux/actions/subProjectFormSetting'

export default function ProjectCoMaker(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)
  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    // setSchema(mockSchema)
    if (mode == 'preView' && formId) {
      handleGetSchemaPreView()
    } else if (subProjectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])
  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // const _schema = mockSchema //await getProjectName(proposalId)
      let _schema = await getFormProjectCoMaker(subProjectId)
      setSchema(_schema)
      setIsEditWidget({
        projectCoMaker: _schema.forms?.projectCoMaker?.id ? false : true,
      })

      setShowEditAll(!_schema.forms?.projectCoMaker?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPreView = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let _schema = await getSettingFormProjectCoMakerPreView(formId)

      setSchema(_schema)
      setIsEditWidget({
        projectCoMaker: true,
      })

      setShowEditAll(false)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProject mode={mode}>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          {/* <MainProjectInfo schema={schema?.info?.projectInfo} /> */}

          {showEditAll && (
            <>
              <BtnEditAll
                onClickEditAll={getIsEditAll(isEditWidget)}
                routing={schema.buttonRoute}
                setOnClickEditAll={(_isEdit) =>
                  setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)
                }
                editWidget={isEditWidget}
                forms={schema?.forms}
              />
            </>
          )}

          {schema?.forms?.projectCoMaker && (
            <ProjectCoMakerWidget
              showCommandButton={!schema.forms.projectCoMaker.disabled}
              schema={schema.forms.projectCoMaker}
              isEdit={isEditWidget.projectCoMaker}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('projectCoMaker', _isEdit, setIsEditWidget)
              }
            />
          )}
        </SidebarProposal>
      )}
    </>
  )
}
